import { Component, Input, SimpleChanges } from '@angular/core';
import { SharedService } from '@services/shared.service';
import { CouponModel } from '@shared/models/CouponModel';
import { IQuantifiable } from '@shared/models/Interfaces';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-coupon-quantity',
  templateUrl: './coupon-quantity.component.html',
  styleUrls: ['./coupon-quantity.component.scss']
})
export class CouponQuantityComponent {

  @Input() model: CouponModel;

  productQuantity = 1;

  validCloseAlert = true;
  validShowAlert = false;
  maxQuantitySelected: number = 0;

  constructor(public sharedService: SharedService) { }

  ngOnInit() {

    this.maxQuantitySelected = this.model.maxQuantity - this.model.quantityAccepted;
    this.productQuantity = 1;
  }

  ngOnChanges(changes: SimpleChanges) {

    for (const propName in changes) {
      if (propName === 'model') {
        const change = changes[propName];
        if (change.isFirstChange() && (change.previousValue !== change.currentValue)) {

          this.productQuantity = this.model ? this.model.quantitySelected : 1;
        }
      }
    }
  }

  changeQuantity(isAdd: boolean, isQuantityDefault: boolean) {

    let quantitySelected = this.model.quantitySelected;   

    // valida si hay que sumar o restar la cantidad
    if (isAdd) {

      quantitySelected = quantitySelected + 1;
    } else {

      quantitySelected = quantitySelected - 1;
    }

    // valid que la compra no exceda los limites
    if (quantitySelected >= 1 && quantitySelected <= this.maxQuantitySelected) {

      this.model.quantitySelected = Number(quantitySelected);
      this.productQuantity = quantitySelected;

      // this.sharedService.setChangeProductQuantity(this.model);
    } else {

      if (isAdd) {

        this.validShowAlert = true;
        this.validCloseAlert = false;

        // Close the alert
        setTimeout(() => this.closeAlert(), 4000);
      } else {

        this.closeAlert();
      }
    }
  }

  closeAlert() {

    this.validShowAlert = false;
    this.validCloseAlert = true;
  }
}
